import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from '../../../shared/components/grid-view/grid-view.component';
import { GlobalServices } from '../../services/global.service';
import { RequestHistoryService } from '../../services/request-history.service';
import { RequestHistoryListing } from '../../models/listing.model';
import { Languages } from '../../models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-request-history',
  templateUrl: './request-history.component.html'
})

export class RequestHistoryComponent implements OnInit {
  public reqHistoryData: RequestHistoryListing;
  pageSize = 15;
  public currentLanguage;
  private itemsMenu: MenuItem[] = [];
  @ViewChild('RequestHistory',{static: false}) gridView: GridViewComponent;
  public currentUser: User = new User();

  constructor(private requestHistoryService: RequestHistoryService, private global: GlobalServices,
              private authenticationService: AuthenticationService, private translate: TranslateService)
  {

    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;
  }

  ngOnInit()
  {

    this.global.isLoaderEnabled = true;
    document.getElementById('main').scrollIntoView({ behavior: 'smooth' });
    if(history.state.data != undefined && history.state.data.requestId != undefined)
    {
      this.initializeRequestHistory();
    }
    else if(this.global.historyData.length > 0)
    {
      if(navigator.userAgent.indexOf('Edge') >= -1)
      {
        window.history.pushState({data:{
          requestId: this.global.historyData[0].reqHistoryData.requestId,
          isRequestHistory: this.global.historyData[0].reqHistoryData.isRequestHistory
        }}, "");
      }
      else
      {
        history.state.data = {
                                requestId: this.global.historyData[0].reqHistoryData.requestId,
                                isRequestHistory: this.global.historyData[0].reqHistoryData.isRequestHistory
                              };
        }
      this.initializeRequestHistory();
      this.global.historyData = [];
    }
    else
    {
        window.history.back();
    }
  }

  initializeRequestHistory()
  {
    this.currentLanguage = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.loadItemsMenu();
    if(this.currentUser.IsAdmin)
    {
        this.loadAdminRequestHistory();
    }
    else
    {
        this.loadUserRequestHistory();
    }
  }

  loadAdminRequestHistory()
  {
    this.requestHistoryService.getAdminRequestHistory(history.state.data.requestId).subscribe(
            data => this.reqHistoryData = data.Data,
            () => console.log("Something went wrong!!"),
            () => this.loadRequestHistoryCompleted()
        );
  }

  loadUserRequestHistory()
  {
    this.requestHistoryService.getUserRequestHistory(history.state.data.requestId, this.currentUser.UserName).subscribe(
    data => this.reqHistoryData = data.Data,
    () => console.log("Something went wrong!!"),
    () => this.loadRequestHistoryCompleted()
    );
  }

  loadRequestHistoryCompleted() {
    this.gridView.loadGrid(this.reqHistoryData,
                           this.reqHistoryData == null ? 0 : this.reqHistoryData.TotalNumber,
                           this.pageSize, "", "SHARED.MYREQUESTS", this.itemsMenu, "", "", 'RequestHistory');
    this.global.isLoaderEnabled = false;
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
  }


}

export class MenuItem {
  Title :string;
  TitleAr :string;
};
